import { min } from 'lodash-es'
import jstat from 'jstat'
import { throttle, timeNow, toPrecision } from 'commons-mathrail/shared/fns'
import { opsLogApplicationIdentifier } from './system-state'
import { currentResolution, editor, fpsHistory } from '../editor/editor-state'

const events = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel']
const idleTimeout = 60 * 1_000 // 1 minute
let idleTime = 0
let lastActive = null
let timer

const getOpenIdleTime = () => lastActive ? timeNow() - lastActive : 0

export const setupIdleMeasurement = () => {
  const reset = () => {
    if (lastActive) {
      idleTime += getOpenIdleTime()
      lastActive = null
    }
    window.clearTimeout(timer)
    timer = window.setTimeout(() => {
      lastActive = timeNow()
    }, idleTimeout)
  }

  const onEvent = throttle(reset, 200)
  for (const event of events) {
    window.addEventListener(event, onEvent, { passive: true })
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      onEvent()
    }
  })
  reset()
}

const pageSessionDuration = () => Math.round(timeNow() - (idleTime + getOpenIdleTime()))

export const getPageSessionEvent = () => ({
  severity: 'info',
  activity: 'Application',
  identifier: opsLogApplicationIdentifier,
  name: 'pageSession',
  data: {
    duration: pageSessionDuration(),
    fps: fpsStats()
  }
})

const fpsStats = () => {
  const values = fpsHistory.value.concat(editor.value?.handlers.getFpsLog() ?? [])
  const count = values.length
  if (!count) {
    return
  }
  const stat = jstat(values)
  const round = toPrecision(3)
  return {
    count,
    avg: round(stat.mean()),
    stdev: round(stat.stdev(true)),
    q5: count > 20 ? round(stat.quantiles([0.05])[0]) : min(values),
    res: currentResolution.value
  }
}
